export const BALANCE_STATUS = {
  opened: {
    textClass: 'text-warning',
    description: 'Este balanço ainda pode sofrer alterações nos valores',
  },
  paid: {
    textClass: 'text-success',
    description:
      'Este balanço já fechou e você recebeu o pagamento do valor total',
  },
  error: {
    textClass: 'text-error',
    description:
      'Algo deu errado ao tentar efetuar o pagamento, tentaremos novamente em breve',
  },
}

export const PURCHASE_STATUS = {
  canceled: {
    textClass: 'label label-rounded label-error',
  },
  success: {
    textClass: 'label label-rounded label-success',
  },
}

export const LANGUAGES = {
  pt: {
    label: 'Português',
    brand: require('@/assets/countries/br.png'),
  },
  en: {
    label: 'English',
    brand: require('@/assets/countries/us.png'),
  },
}
